import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const CookieConsent: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Don't show cookie consent on privacy policy page
    if (location.pathname === "/privacy-policy") {
      setIsVisible(false);
      return;
    }

    // Check if user has already given consent
    const hasConsent = localStorage.getItem("cookieConsent");
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, [location.pathname]);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false);
  };

  const handlePrivacyPolicy = () => {
    window.open("/privacy-policy", "_blank");
  };

  const handleDismiss = () => {
    setIsVisible(false);
    // Note: This dismisses without setting consent, so popup will appear again on next visit
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-800 text-white shadow-lg border-t border-gray-600">
      <div className="container px-3 py-2">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          {/* Cookie notice text */}
          <p className="flex-1 m-0 text-sm leading-5 sm:leading-relaxed text-gray-200">
            This site uses cookies to analyze traffic and measure performance.
            We encourage you to read our privacy policy and terms of use to
            learn more.
          </p>

          {/* Buttons + Close */}
          <div className="flex flex-row gap-2 shrink-0 items-center justify-center sm:justify-end">
            <button
              onClick={handlePrivacyPolicy}
              className="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-blue-400 whitespace-nowrap"
            >
              Privacy policy
            </button>

            <button
              onClick={handleAccept}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 whitespace-nowrap"
            >
              Ok
            </button>

            <button
              onClick={handleDismiss}
              className="p-2 text-gray-400 hover:text-white hover:bg-gray-700 rounded transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-gray-500"
              aria-label="Dismiss cookie notice"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
